<template>
  <div>
    <div class="addressManageContent main-wrap">
      <div class="main-top">
        <el-button type="primary" class="addAddress h40" @click="rowAdd" icon="iconfont iconxinzeng">
          {{ $lang('问题报告') }}
        </el-button>
        <div class="searchParam" id="jmsSearch">
          <el-form :model="searchParam" ref="searchParam" :inline="true">
            <el-form-item prop="workOrderNos" :label="$lang('问题编号') + ':'">
              <el-input v-model="searchParam.workOrderNos" :placeholder="$lang('请输入问题编号')"></el-input>
            </el-form-item>
            <el-form-item prop="waybillNos" :label="$lang('运单号') + ':'">
              <el-input v-model="searchParam.waybillNos" :placeholder="$lang('请输入运单号')"></el-input>
            </el-form-item>
            <el-form-item prop="customerOrderId" :label="$lang('客户订单号') + ':'">
              <el-input v-model="searchParam.customerOrderId" :placeholder="$lang('请输入客户订单号')"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('一级类型') + ':'" prop="firstTypeId">
              <el-select clearable v-model="searchParam.firstTypeId" filterable @change="firstTypeCodeChange($event,1)">
                <el-option
                    v-for="item in firstTypeCodeList"
                    :key="item.id"
                    :label="$lang(item.name)"
                    :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('二级类型') + ':'" prop="secondTypeId">
              <el-select clearable v-model="searchParam.secondTypeId" filterable @change="dataCityChange($event)">
                <el-option
                    v-for="item in secondTypeCodeList"
                    :key="item.id"
                    :label="$lang(item.name)"
                    :value="item.id"
                />
              </el-select>
            </el-form-item>
            <!-- <BaseAddress ref="reciveProvinceSearch" :showLevel="3" v-model="searchParam.reciveCity" @changeValue="changeValue"> </BaseAddress> -->
            <el-form-item prop="date" :label="$lang('登记时间') + ':'">
              <el-date-picker
                  :clearable="false"
                  v-model="searchParam.date"
                  type="datetimerange"
                  :default-time="['00:00:00', '23:59:59']"
                  :range-separator="$lang('至')"
                  :start-placeholder="$lang('开始日期')"
                  :end-placeholder="$lang('结束日期')"
                  class="commonSize"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="status" :label="$lang('状态') + ':'">
              <el-select clearable v-model="searchParam.status" filterable :placeholder="$lang('请选择状态')">
                <el-option
                    v-for="item in statusDict"
                    :key="item.id"
                    :label="$lang(item.name)"
                    :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="searchChange">{{
                  $lang('查询')
                }}
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" plain icon="iconfont iconshanchu" class="h32" @click="resetSearch">
                {{ $lang('清空') }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="main-table">
        <JmsTableScroll
            ref="params"
            :option="listOpt"
            :data="tableList"
            :page="page"
            :table-loading="loading"
            @size-change="sizeChange"
            @select-change="selectionChange"
            @current-change="currentChange">
          <template slot="isDefault" slot-scope="data">
            <el-switch
                v-model="data.row.isDefault"
                active-color="#13ce66"
                inactive-color="#dcdfe6"
                :active-value="1"
                :inactive-value="2"
                disabled>
            </el-switch>
          </template>
          <template slot="menu" slot-scope="scope">
            <div>
              <el-button @click="rowView(scope.row.id)" type="text">{{ $lang('查看') }}</el-button>
            </div>
          </template>
        </JmsTableScroll>
      </div>

      <Modal :editDialogVisible="editDialogVisible" @closeMoadl="closeMoadl"></Modal>
      <Detail :editDialogVisible="detailVisible" @closeMoadl="closeMoadl" :modalData="modalData"></Detail>
    </div>
  </div>
</template>
<script>

import JmsTableScroll from '@/components/jms-widget/jms-table-scroll/index.vue'
import mixin from '@/mixins/mixin'
import { commonFun } from '@utils/common'
import { RESPONSE_SUCCESS } from '@constants'
import { workOrderAdd, workOrderPage, workOrderFirstType, workOrderSecondType, workOrderDetail } from './pool'
import Modal from './components/Modal.vue'
import Detail from './components/Detail.vue'
export default {
  name: 'CustomerService',
  components: { Detail, JmsTableScroll, Modal },
  mixins: [mixin],
  data() {
    let choiceDate = ''
    return {
      COM_HTTP: {
        reqList: workOrderPage,
        reqAdd: workOrderAdd,
        // reqUpdate: updateAddress,
        // reqDel: delAddress,
      },
      tableList: [],
      loading: false, // 加载状态
      page: {
        // 分页配置
        current: 1,
        size: 100,
        total: 0,
        sizes: [
          50,
          100,
          200,
          500,
          1000,
        ],
      },
      searchParam: {
        date: [commonFun.GetTodayDate(-6)[0], commonFun.GetTodayDate()[1]],
        workOrderNos: '',
        waybillNos: '',
        customerOrderId: '',
        firstTypeId: '',
        secondTypeId: '',
        status: ''
      },
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          choiceDate = minDate.getTime()
          if (maxDate) {
            choiceDate = ''
          }
        },
        disabledDate: time => {
          if (choiceDate) {
            const limitRange = 59 * 24 * 3600 * 1000 // 60天范围内可选
            const maxTime = choiceDate + limitRange
            const minTime = choiceDate - limitRange
            return time.getTime() > maxTime || time.getTime() < minTime
          } else {
            return false
          }
        },
      },
      statusDict: [
        {
          id: 1,
          name: '待分配'
        },
        {
          id: 2,
          name: '处理中'
        },
        {
          id: 3,
          name: '已关闭'
        },
      ],
      firstTypeCodeList: [],
      secondTypeCodeList: [],
      editDialogVisible: false,
      detailVisible: false,
      modalData: {}
    }
  },
  computed: {
    listOpt() {
      return {
        fixHeight: 90,
        border: true,
        selection: false,
        menu: true,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        menuWidth: 150,
        rowKey: '$index',
        column: [
          {
            label: '问题编号',
            prop: 'workOrderNo',
          },
          {
            label: '状态',
            prop: 'statusStr',
          },
          {
            label: '运单号',
            prop: 'waybillNo',
          },
          {
            label: '客户订单号',
            prop: 'customerOrderId',
          },
          {
            label: '登记时间',
            prop: 'createTime',
          },
          {
            label: '一级类型',
            prop: 'firstTypeName',
          },
          {
            label: '二级类型',
            prop: 'secondTypeName',
          },
          {
            label: '问题描述',
            prop: 'problemDescription',
          },
          {
            label: '处理结果',
            prop: 'handlingOpinions',
          },
        ],
      }
    },
  },
  created() {
    this.getFirstTypeCodeListFun()
  },
  methods: {
    async getFirstTypeCodeListFun() {
      console.log('-------')
      await workOrderFirstType({}).then(res => {
        const { code, data } = res
        if (code === RESPONSE_SUCCESS) {
          this.firstTypeCodeList = data || []
        }
      })
    },
    firstTypeCodeChange($event) {
      this.searchParam.secondTypeId = ''
      this.secondTypeCodeList = []
      this.getSecondTypeCodeListFun($event)
    },
    async getSecondTypeCodeListFun(id) {
      await workOrderSecondType({ firstId: id }).then(res => {
        const { code, data } = res
        if (code === RESPONSE_SUCCESS) {
          this.secondTypeCodeList = data || []
        }
      })
    },
    dataCityChange($event) {
      console.log($event)
    },
    async searchFun() {
      this.$refs.searchParam.validate((valid, values) => {
        if (valid) {
          // console.log(this.searchParam)
          this.loading = true
          const param = JSON.parse(JSON.stringify({ current: this.page.current, size: this.page.size,
            registrationStartTime: this.searchParam.date[0],
            registrationEndTime: this.searchParam.date[1],
            ...this.searchParam }))
          // console.log(param)
          delete param.date
          param.workOrderNos ? param.workOrderNos = param.workOrderNos.split(',') : param.workOrderNos = []
          param.waybillNos ? param.waybillNos = param.waybillNos.split(',') : param.waybillNos = []
          this.COM_HTTP.reqList(param).then(res => {
            const { code, msg } = res
            this.loading = false
            if (code === RESPONSE_SUCCESS) {
              // this.cost = data.cost
              // this.$message.success(this.$lang('查询成功！'))
              this.tableList = res.data.records || []
              this.page.total = res.data.total || 0
              this.page.current = res.data.current || 1
            } else {
              this.$message.error(this.$lang(msg))
            }
          })
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    // 选择分页条数
    sizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.searchFun()
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.searchFun()
    },
    resetSearch() {
      this.firstTypeCodeList = []
      this.secondTypeCodeList = []
      this.$refs.searchParam.resetFields()
      this.getFirstTypeCodeListFun()

      this.searchParam = {
        date: [commonFun.GetTodayDate(-6)[0], commonFun.GetTodayDate()[1]],
        firstTypeId: null,
        secondTypeId: null
      }
      this.page.current = 1
      this.page.size = 100
    },
    rowAdd() {
      this.editDialogVisible = true
    },
    closeMoadl() {
      this.editDialogVisible = false
      this.detailVisible = false
      this.modalData = {}
      this.searchFun()
    },
    // 获取查看详情
    async rowView(id) {
      this.loading = true
      await workOrderDetail({ workOrderId: id }).then(res => {
        this.loading = false
        const { code, data, msg } = res
        if (code === RESPONSE_SUCCESS) {
          this.modalData = data
          this.detailVisible = true
        } else {
          this.$message.error(this.$lang(msg))
          this.modalData = {}
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
body {
  ::v-deep .my-kqoption {
    width: 800px !important;
  }
}

.el-autocomplete {
  ::v-deep .my-kqoption {
    width: auto !important;
  }
}

.addressManageContent {
  .main-top {
    padding: 16px 24px;
  }

  .main-table {
    padding: 12px 24px;
    background: #edeef3;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .searchParam {
    display: inline-flex;
    width: 100%;
    position: relative;
    margin-top: 10px;

    .searchParamInput {
      padding-right: 16px;
    }

    .el-button {
      height: 32px;
    }

    .addAddress {
      position: absolute;
      right: 0;
      height: 32px;
    }
  }

  .dot.oragin::before {
    width: 8px;
    height: 8px;
    background: #e60012;
  }

  /*.dot.green::before {*/
  /*  background: #52C41A;*/
  /*}*/
  .el-dialog {
    .el-dialog__body {
      .myDetail {
        display: inline-flex;
        padding: 0 0 24px 0;

        .myDetailItem {
          width: 200px;
          padding: 0 8px;

          .myDetailItemText {
            padding-bottom: 4px;
          }
        }
      }

      .addressDeatil {
        .el-input {
          width: 360px !important;
        }
      }
    }

    .reuqire {
      color: red;
    }

    .el-dialog__header {
      padding: 12px 25px !important;
      border-bottom: 1px solid #eeeeee;
    }
  }
}

.oper {
  position: absolute;
  right: 20px;
  bottom: 5px;
  cursor: pointer;
  color: #333;

  .red {
    color: red;
    margin-right: 20px;
  }
}
</style>
<style lang="scss">
.addressManageContent {
  .el-table__fixed, .el-table__fixed-right {
    height: 705px !important;
  }
}
</style>
